import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { IDashExtServerSettings } from '../../../../types/IEditableServerSettings';

export interface IUpdateExtensionsServerSettingsParams {
  settings: IDashExtServerSettings;
}

export type IUpdateExtensionsServerSettingsResult = IResult & IDashExtServerSettings;

export class UpdateExtensionsServerSettingsRequest extends Request<IUpdateExtensionsServerSettingsParams, IUpdateExtensionsServerSettingsResult> {
  constructor(params: IUpdateExtensionsServerSettingsParams) {
    super('updateExtensionsServerSettings', params);
  }
}
